export default __webpack_public_path__ + "2343404b55a4bfdb8ed346a0534efdd7.svg";